// src/shared-components/forms/add-board-content/add-article/ArticleWrapper.jsx
import { useParams } from 'react-router-dom';

import Article from './article'; // make sure this path exactly matches your file structure

export default function ArticleWrapper() {
  const { articleId } = useParams();
  // Giving <Article> a key that equals the param forces a full remount
  return <Article key={articleId} />;
}
